/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { List } from 'immutable';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import {
  getIsNewLoyaltyBanner,
  getIsABLoaded,
  estimatedTaxBagPageEnabled,
  getIsInternationalShipping,
  getIsPLCCInstantCheckout,
  getExtendedPreOrderValue,
  isPlacePerkEnabled,
  getIsFreeShippingMessagingEnabled,
  getPlccICForRememberedUserEnabled,
  getIsFreeShippingLedgerMessageEnabled,
  getOrderSubtotalEnhancementEnabled,
  getOrderTrackingEnhancementEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getIsGuest,
  isPlccUser,
  getUserZipCode,
  getUserLoggedInState,
  getUserName,
  isRememberedUser,
  getDefaultAddress,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  resetEddData,
  clearEddTTL,
  hideLoader,
} from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.actions';
import { getCurrencyAttributesAsArray } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import GiftCardSelector from '@tcp/core/src/components/features/CnC/Checkout/organisms/GiftCardsSection/container/GiftCards.selectors';
import BagPageSelector, {
  getFreeShippingThresholdValue,
  getFreeShippingType,
  getIsFreeShippingCouponApplied,
  getIsPlccCheckoutEnabled,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import CheckoutSelectors, {
  getLoginV2FlowEnabled,
  isPickupAlt,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import {
  getAddressListState,
  getPreferredAddress,
} from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.selectors';
import {
  getCartLoadingState,
  getOrderDetails,
  getOrderShipments,
  getZipCodeTaxError,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { getAddToBagInProgress } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.selectors';
import { updateStoreItem as updateItem } from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.actions';
import * as PickupSelectors from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.selectors';
import {
  getBossGCAndPreOrderCase,
  getBossAndPreOrder,
  getBossAndGC,
  checkIsShippingDetailsSaved,
  getOrderProducts,
  getBossInEligible,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import AddedToBagReducer from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.reducer';
import AddedToBagSaga from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.saga';
import { verifyExpiredCoupons } from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.selectors';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import AddressBookReducer from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.reducer';
import AddressBookSaga from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.saga';
import OrderLedger from '../views/orderLedger.view';
import { getLedgerSummaryData, getProductTotal } from './orderLedger.selector';
import confirmationSelectors, {
  getConfirmationProductTotal,
} from '../../../../Confirmation/container/Confirmation.selectors';
import checkoutSelectors from '../../../../Checkout/container/Checkout.selector';
import {
  getViewportInfo,
  parseBoolean,
  checkExtendedPreOrderItem,
} from '../../../../../../../utils';
import BagPageActions, {
  taxFromDefaultAddress,
  isPlccIsShippingAddressModalOpen,
  plccShippingAddressUpdate,
  isPlccIsPickupModalOpen,
  togglePlccLoginModal,
} from '../../../../BagPage/container/BagPage.actions';
import { getUserProfileData } from '../../../../../browse/ApplyCardPage/container/ApplyCard.selectors';
import { setIsPlccICFired } from '../../../../AddedToBag/container/AddedToBag.actions';
import { updateSectionState } from '../../../../SinglePageCheckout/container/SinglePageCheckout.actions';
import { SPC_SECTION } from '../../../../SinglePageCheckout/container/SinglePageCheckout.constants';

const { getVenmoPayment, isVenmoOrderPayment } = checkoutSelectors;

const getTotalTaxes = (
  isEstimatedTaxFormEnabled,
  calculatedEstimatedTax,
  taxesTotal,
  spc,
  isShippingSectionSaved,
  isPlccShippingAddressUpdated,
  pageCategory
) => {
  let tax;
  if (!isEstimatedTaxFormEnabled && (taxesTotal || taxesTotal === 0)) {
    tax = taxesTotal;
  } else if (
    ((taxesTotal || taxesTotal === 0) && pageCategory !== 'bagPage' && isShippingSectionSaved) ||
    isPlccShippingAddressUpdated
  ) {
    tax = taxesTotal;
  } else {
    tax = parseFloat(calculatedEstimatedTax || 0);
  }
  return tax;
};

const getOrderTotal = (isEstimatedTaxFormEnabled, calculatedEstimatedTax, orderBalanceTotal) => {
  return isEstimatedTaxFormEnabled && calculatedEstimatedTax
    ? orderBalanceTotal + parseFloat(calculatedEstimatedTax || 0)
    : orderBalanceTotal;
};

const getReturnZip = (fn) => {
  const tcpZipPromise = readCookie('tcpZip');
  let zipcode = null;
  if (tcpZipPromise) {
    zipcode = tcpZipPromise?.split('+')[0].split('-')[0];
    fn(zipcode);
  }
};

const getSavedZipCode = (props) => {
  const {
    addressList,
    shippingZip,
    taxFromDefaultShippingAddress,
    shippingCheckoutAddress,
    pageCategory,
    ledgerSummaryData,
    defaultAddress,
    userZipCode,
  } = props;
  let zipcode = null;
  const { zipForTaxEstimation } = ledgerSummaryData || {};
  if (shippingCheckoutAddress && shippingCheckoutAddress.zipCode) {
    //  first pick address from checkout shipping address
    zipcode = shippingCheckoutAddress.zipCode;
  } else if (List.isList(addressList) && addressList?.size && defaultAddress) {
    // first pick the zipcode from shipping address from addressbook
    zipcode = defaultAddress?.postalCode;
    if (pageCategory === 'bagPage') {
      taxFromDefaultShippingAddress(!zipForTaxEstimation);
    }
  } else if (userZipCode) {
    zipcode = userZipCode;
  } else if (shippingZip) {
    // then pick the zipcode from shipping adderess from orderDetails state
    zipcode = shippingZip;
  }
  return zipcode;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const OrderLedgerContainer = (props) => {
  const {
    className,
    ledgerSummaryData,
    showAccordian,
    confirmationPageLedgerSummaryData,
    isConfirmationPage,
    orderLedgerAfterView,
    pageCategory,
    navigation,
    bagLoadingSection,
    bagLoadingPageLevel,
    isVenmoPaymentInProgress,
    venmoPayment,
    venmoPaymentInfo,
    spc,
    spcBag,
    isCollapseDisabled,
    isCartLoading,
    newBag,
    isNewLoyaltyBanner,
    isPlcc,
    isStickyCheckoutButtonEnabled,
    isABTestLoaded,
    getEstimatedTaxAction,
    getIsFromEstimatedTaxForm,
    isEstimatedTaxBagPageEnabled,
    zipCodeTaxError,
    isTaxCalculated,
    isFromSpcOrderLedger,
    isFromCheckoutPage,
    isInternationalShipping,
    currencyAttributes,
    isShippingSectionSaved,
    cartType,
    storeAdress,
    isLoggedIn,
    userContactInfo,
    isPlccCheckoutEnabled,
    userName,
    isPlccCheckoutEnabledSwitch,
    IsPlccICAddressModalOpen,
    isPlccIsShippingAddressModalOpenAtn,
    handlePlccCheckout,
    userShippingAddress,
    rememberedUserFlag,
    taxFromDefaultShippingAddress,
    bossGCAndPreOrderCase,
    verifyAllExpiredCoupons,
    userDefaultStore,
    updateStoreItem,
    productItems,
    bossAndPreOrder,
    bossAndGC,
    defaultAddress,
    shippingCheckoutAddress,
    appliedGiftCards,
    resetEDDCall,
    nonCacheBagLoading,
    trackAnalyticClick,
    isNonCacheDataLoaded,
    isPlccShippingAddressUpdated,
    plccShippingAddressUpdateActn,
    extendedOrderThreshold,
    defaultStore,
    isPlccICPickupModalOpen,
    isPlccIsPickupModalOpenAtn,
    orderDetails,
    isLoginV2FlowEnabled,
    isHasPickUpAlternatePerson,
    isAddToBagInProgress,
    placePerkEnabled,
    wrapSection,
    orderItemsCount,
    renderCondForPLCCTopBanner,
    freeShippingMessagingEnabled,
    defaultAddressForRemUser,
    plccICForRemberedUser,
    plccLoginModalState,
    togglePlccModalStateAction,
    freeShippingThreshold,
    isFreeShippingLedgerMessageEnabled,
    freeShippingThresholdValue,
    orderSubtotalEnhancementEnabled,
    productTotal,
    productTotalConfirmation,
    bossInEligible,
    isFreeShippingCouponApplied,
    freeShippingPromoType,
    updateSectionStateAtn,
    shipments,
    orderTrackingEnhancementEnabled,
  } = props;
  const isPickupOrder = cartType === 'PURE_BOSS' || cartType === 'PURE_BOPIS';
  const storeAddress = defaultStore?.basicInfo?.address;
  const { taxesTotal, orderBalanceTotal, zipForTaxEstimation, calculatedEstimatedTax } =
    ledgerSummaryData || {};
  const bagLoading = bagLoadingSection || bagLoadingPageLevel;
  const [tcpZipPromise, setTcpZipPromise] = useState('');
  const isEstimatedTaxFormEnabled = isEstimatedTaxBagPageEnabled && pageCategory === 'bagPage';
  const isEstimatedTaxFormEnabledSpc = isEstimatedTaxBagPageEnabled;
  const [containsExtendedOrder, setContainsExtendedOrder] = useState(false);
  const [extendedProductItemsIdArray, setExtendedProductItemsIdArray] = useState([]);

  const savedZipCode = useMemo(
    () => getSavedZipCode(props),
    [defaultAddress, shippingCheckoutAddress]
  );

  const updatedLedgerSummaryData = useMemo(() => {
    let taxesTotalModified = taxesTotal;
    let orderBalanceTotalWithTax = orderBalanceTotal;
    if (ledgerSummaryData) {
      orderBalanceTotalWithTax = getOrderTotal(
        isEstimatedTaxFormEnabled,
        calculatedEstimatedTax,
        orderBalanceTotal
      );
      taxesTotalModified = getTotalTaxes(
        isEstimatedTaxFormEnabled,
        calculatedEstimatedTax,
        taxesTotal,
        spc,
        isShippingSectionSaved,
        isPlccShippingAddressUpdated,
        pageCategory
      );
      return {
        ...ledgerSummaryData,
        orderBalanceTotal: orderBalanceTotalWithTax,
        taxesTotal: taxesTotalModified,
      };
    }
    return ledgerSummaryData;
  }, [
    ledgerSummaryData,
    isEstimatedTaxFormEnabled,
    isShippingSectionSaved,
    isPlccShippingAddressUpdated,
    pageCategory,
  ]);

  const findExtendedPreOrderItem = () => {
    if (productItems && productItems.length) {
      const productItemArray = [...productItems];
      const preOrderItems = productItemArray.filter(
        (productItem) =>
          productItem.miscInfo?.variantPreOrderMap?.preOrderDate ||
          productItem.itemInfo.preOrderDate
      );
      if (preOrderItems.length > 0) {
        preOrderItems.every((item) => {
          const index = extendedProductItemsIdArray.findIndex((d) => d === item.itemInfo.itemId);
          if (index === -1 && checkExtendedPreOrderItem(preOrderItems, extendedOrderThreshold)) {
            setContainsExtendedOrder(true);
            setExtendedProductItemsIdArray([...extendedProductItemsIdArray, item.itemInfo.itemId]);
            return false;
          }
          return true;
        });
      } else {
        productItemArray.every((item, i) => {
          const index = extendedProductItemsIdArray.findIndex((d) => d === item.itemInfo.itemId);
          if (index !== -1) return false;
          if (i + 1 === productItemArray.length) {
            setContainsExtendedOrder(false);
          }
          return true;
        });
      }
    }
  };

  useEffect(() => {
    findExtendedPreOrderItem();
  }, [productItems]);

  useEffect(() => {
    getReturnZip(setTcpZipPromise);
    findExtendedPreOrderItem();
  }, []);
  const hasAppliedGiftCards = appliedGiftCards?.size > 0;
  return (
    <OrderLedger
      className={className}
      userShippingAddress={userShippingAddress}
      taxFromDefaultShippingAddress={taxFromDefaultShippingAddress}
      IsPlccICAddressModalOpen={IsPlccICAddressModalOpen}
      isPlccIsShippingAddressModalOpenAtn={isPlccIsShippingAddressModalOpenAtn}
      ledgerSummaryData={updatedLedgerSummaryData}
      trackAnalyticClick={trackAnalyticClick}
      plccShippingAddressUpdateActn={plccShippingAddressUpdateActn}
      showAccordian={showAccordian}
      isNonCacheDataLoaded={isNonCacheDataLoaded}
      getIsFromEstimatedTaxForm={getIsFromEstimatedTaxForm}
      orderLedgerAfterView={orderLedgerAfterView}
      confirmationPageLedgerSummaryData={confirmationPageLedgerSummaryData}
      isConfirmationPage={isConfirmationPage}
      pageCategory={pageCategory}
      navigation={navigation}
      bagLoading={bagLoading}
      isVenmoPaymentInProgress={isVenmoPaymentInProgress}
      venmoPayment={venmoPayment}
      venmoPaymentInfo={venmoPaymentInfo}
      spc={spc}
      resetEDDCall={resetEDDCall}
      spcBag={spcBag}
      isCollapseDisabled={isCollapseDisabled || isConfirmationPage}
      isCartLoading={isCartLoading}
      newBag={newBag}
      isNewLoyaltyBanner={isNewLoyaltyBanner}
      isPlcc={isPlcc}
      isStickyCheckoutButtonEnabled={isStickyCheckoutButtonEnabled}
      isABTestLoaded={isABTestLoaded}
      getEstimatedTaxAction={getEstimatedTaxAction}
      isEstimatedTaxFormEnabled={isEstimatedTaxFormEnabled}
      isEstimatedTaxFormEnabledSpc={isEstimatedTaxFormEnabledSpc}
      zipCode={
        isPickupOrder ? storeAddress?.zipCode : zipForTaxEstimation || savedZipCode || tcpZipPromise
      }
      zipCodeTaxError={zipCodeTaxError}
      isTaxCalculated={isTaxCalculated}
      isFromSpcOrderLedger={isFromSpcOrderLedger}
      isFromCheckoutPage={isFromCheckoutPage}
      isInternationalShipping={isInternationalShipping}
      currencyAttributes={currencyAttributes}
      orderType={cartType}
      storeAdress={storeAdress}
      isLoggedIn={isLoggedIn}
      userContactInfo={userContactInfo}
      isPlccCheckoutEnabled={isPlccCheckoutEnabled && !hasAppliedGiftCards}
      userName={userName}
      isPlccCheckoutEnabledSwitch={isPlccCheckoutEnabledSwitch}
      handlePlccCheckout={handlePlccCheckout}
      rememberedUserFlag={rememberedUserFlag}
      bossGCAndPreOrderCase={bossGCAndPreOrderCase}
      verifyAllExpiredCoupons={verifyAllExpiredCoupons}
      userDefaultStore={userDefaultStore}
      updateStoreItem={updateStoreItem}
      productItems={productItems}
      bossAndPreOrder={bossAndPreOrder}
      bossAndGC={bossAndGC}
      containsExtendedOrder={containsExtendedOrder}
      isPlccICPickupModalOpen={isPlccICPickupModalOpen}
      isPlccICPickupModalOpenAtn={isPlccIsPickupModalOpenAtn}
      orderDetails={orderDetails}
      isLoginV2FlowEnabled={isLoginV2FlowEnabled}
      isHasPickUpAlternatePerson={isHasPickUpAlternatePerson}
      isPlccShippingAddressUpdated={isPlccShippingAddressUpdated}
      isAddToBagInProgress={isAddToBagInProgress}
      isPlacePerkEnabled={placePerkEnabled}
      nonCacheBagLoading={nonCacheBagLoading}
      wrapSection={wrapSection}
      orderItemsCount={orderItemsCount}
      renderCondForPLCCTopBanner={renderCondForPLCCTopBanner}
      freeShippingMessagingEnabled={freeShippingMessagingEnabled}
      defaultAddressForRemUser={defaultAddressForRemUser}
      plccICForRemberedUser={plccICForRemberedUser}
      plccLoginModalState={plccLoginModalState}
      togglePlccModalStateAction={togglePlccModalStateAction}
      freeShippingThreshold={freeShippingThreshold}
      isFreeShippingLedgerMessageEnabled={isFreeShippingLedgerMessageEnabled}
      freeShippingThresholdValue={freeShippingThresholdValue}
      orderSubtotalEnhancementEnabled={orderSubtotalEnhancementEnabled}
      productTotal={productTotal}
      productTotalConfirmation={productTotalConfirmation}
      bossInEligible={bossInEligible}
      isFreeShippingCouponApplied={isFreeShippingCouponApplied}
      freeShippingPromoType={freeShippingPromoType}
      updateSectionStateAtn={updateSectionStateAtn}
      shipments={shipments}
      orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
    />
  );
};

OrderLedgerContainer.propTypes = {
  className: PropTypes.string.isRequired,
  ledgerSummaryData: PropTypes.shape({}).isRequired,
  showAccordian: PropTypes.string.isRequired,
  isConfirmationPage: PropTypes.string.isRequired,
  orderLedgerAfterView: PropTypes.string.isRequired,
  confirmationPageLedgerSummaryData: PropTypes.string.isRequired,
  pageCategory: PropTypes.string.isRequired,
  navigation: PropTypes.string.isRequired,
  bagLoadingSection: PropTypes.bool.isRequired,
  bagLoadingPageLevel: PropTypes.bool.isRequired,
  isVenmoPaymentInProgress: PropTypes.bool.isRequired,
  venmoPaymentInfo: PropTypes.bool.isRequired,
  venmoPayment: PropTypes.shape({}).isRequired,
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
  isCollapseDisabled: PropTypes.bool.isRequired,
  isCartLoading: PropTypes.bool.isRequired,
  newBag: PropTypes.bool,
  isNewLoyaltyBanner: PropTypes.bool,
  isPlcc: PropTypes.bool,
  isABTestLoaded: PropTypes.bool,
  isStickyCheckoutButtonEnabled: PropTypes.bool,
  isFromSpcOrderLedger: PropTypes.bool,
  isFromCheckoutPage: PropTypes.bool,
  trackAnalyticClick: PropTypes.func.isRequired,
  extendedOrderThreshold: PropTypes.number,
  isLoggedIn: PropTypes.bool,
  placePerkEnabled: PropTypes.bool,
};

OrderLedgerContainer.defaultProps = {
  newBag: false,
  isNewLoyaltyBanner: false,
  isPlcc: false,
  spc: false,
  spcBag: false,
  isABTestLoaded: false,
  isStickyCheckoutButtonEnabled: false,
  isFromSpcOrderLedger: false,
  isFromCheckoutPage: false,
  extendedOrderThreshold: 0,
  isLoggedIn: false,
  placePerkEnabled: false,
};

function mapStateToProps(state) {
  const { isDesktop = true } = getViewportInfo() || {};
  const orderType = BagPageSelector.getOrderType(state);
  const getOrderItems = getOrderProducts(state);
  const enableEstimatedTaxSiteDetails = estimatedTaxBagPageEnabled(state);
  const enableEstimatedTax = getIsGuest(state)
    ? parseBoolean(enableEstimatedTaxSiteDetails.GUEST_ESTIMATED_TAX_BAG_PAGE_ENABLED)
    : parseBoolean(enableEstimatedTaxSiteDetails.ESTIMATED_TAX_BAG_PAGE_ENABLED);
  const favStore = PickupSelectors.getDefaultStore(state);
  const geoDefaultStore = PickupSelectors.getGeoDefaultStore(state);
  const defaultStore = favStore || geoDefaultStore || null;
  return {
    className: 'order-summary',
    ledgerSummaryData: getLedgerSummaryData(state),
    bagLoadingSection: BagPageSelector.isBagLoading(state),
    confirmationPageLedgerSummaryData:
      confirmationSelectors.getLedgerSummaryDataConfirmation(state),
    venmoPayment: getVenmoPayment(state),
    isVenmoPaymentInProgress: isVenmoOrderPayment(state),
    isCollapseDisabled: isDesktop,
    isCartLoading: getCartLoadingState(state),
    isNewLoyaltyBanner: getIsNewLoyaltyBanner(state),
    isPlcc: isPlccUser(state),
    isABTestLoaded: getIsABLoaded(state),
    isEstimatedTaxBagPageEnabled: enableEstimatedTax,
    userZipCode: getUserZipCode(state),
    zipCodeTaxError: getZipCodeTaxError(state),
    addressList: getAddressListState(state),
    defaultAddress: getPreferredAddress(state),
    shippingCheckoutAddress: CheckoutSelectors.getShippingAddress(state),
    shippingZip: BagPageSelector.getShippingAddressZip(state),
    isTaxCalculated: BagPageSelector.getIsTaxCalculated(state),
    isTotalCalculatedAmt: BagPageSelector.getIsTotalCalculated(state),
    IsPlccICAddressModalOpen: BagPageSelector.getIsPlccICAddressModalOpen(state),
    isPlccICPickupModalOpen: BagPageSelector.getIsPlccICPickupModalOpen(state),
    isNonCacheDataLoaded: BagPageSelector.isNonCacheDataLoaded(state),
    isPlccShippingAddressUpdated: BagPageSelector.getIsPlccShippingAddressUpdate(state),
    isInternationalShipping: getIsInternationalShipping(state),
    currencyAttributes: getCurrencyAttributesAsArray(state),
    isShippingSectionSaved: checkIsShippingDetailsSaved(state),
    cartType: orderType,
    storeAdress: BagPageSelector.getBossBopisStore(state),
    isLoggedIn: getUserLoggedInState(state),
    userContactInfo: getUserProfileData(state),
    isPlccCheckoutEnabled: getIsPlccCheckoutEnabled(state),
    userName: getUserName(state),
    appliedGiftCards: GiftCardSelector.getAppliedGiftCards(state),
    isPlccCheckoutEnabledSwitch: getIsPLCCInstantCheckout(state),
    userShippingAddress: CheckoutSelectors.getShippingAddress(state),
    rememberedUserFlag: isRememberedUser(state),
    bossGCAndPreOrderCase: getBossGCAndPreOrderCase(state),
    verifyAllExpiredCoupons: verifyExpiredCoupons(state),
    userDefaultStore: PickupSelectors.getUserDefaultPickupStore(state),
    bossAndPreOrder: getBossAndPreOrder(state),
    bossAndGC: getBossAndGC(state),
    defaultStore,
    // eslint-disable-next-line no-underscore-dangle
    productItems: getOrderItems?._tail?.array,
    nonCacheBagLoading: BagPageSelector.isNonCacheBagLoading(state),
    extendedOrderThreshold: getExtendedPreOrderValue(state),
    orderDetails: getOrderDetails(state),
    isLoginV2FlowEnabled: getLoginV2FlowEnabled(state),
    isHasPickUpAlternatePerson: isPickupAlt(state),
    isAddToBagInProgress: getAddToBagInProgress(state),
    placePerkEnabled: isPlacePerkEnabled(state),
    freeShippingMessagingEnabled: getIsFreeShippingMessagingEnabled(state),
    defaultAddressForRemUser: getDefaultAddress(state),
    plccICForRemberedUser: getPlccICForRememberedUserEnabled(state),
    plccLoginModalState: BagPageSelector.getPlccLoginModalState(state),
    freeShippingThreshold: getFreeShippingThresholdValue(state),
    freeShippingThresholdValue: getFreeShippingThresholdValue(state),
    orderSubtotalEnhancementEnabled: getOrderSubtotalEnhancementEnabled(state),
    isFreeShippingLedgerMessageEnabled: getIsFreeShippingLedgerMessageEnabled(state),
    productTotal: getProductTotal(state),
    productTotalConfirmation: getConfirmationProductTotal(state),
    bossInEligible: getBossInEligible(state),
    isFreeShippingCouponApplied: getIsFreeShippingCouponApplied(state),
    freeShippingPromoType: getFreeShippingType(state),
    shipments: getOrderShipments(state),
    orderTrackingEnhancementEnabled: getOrderTrackingEnhancementEnabled(state),
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    taxFromDefaultShippingAddress: (payload) => dispatch(taxFromDefaultAddress(payload)),
    isPlccIsShippingAddressModalOpenAtn: (payload) =>
      dispatch(isPlccIsShippingAddressModalOpen(payload)),
    isPlccIsPickupModalOpenAtn: (payload) => dispatch(isPlccIsPickupModalOpen(payload)),
    plccShippingAddressUpdateActn: (payload) => dispatch(plccShippingAddressUpdate(payload)),
    handlePlccCheckout: (payload) => {
      dispatch(BagPageActions.startPlccCheckout(payload));
      dispatch(setIsPlccICFired(true));
    },
    updateStoreItem: (payload, enableModal) => {
      dispatch(updateItem(payload, enableModal));
    },
    resetEDDCall: () => {
      dispatch(hideLoader());
      dispatch(clearEddTTL());
      dispatch(resetEddData());
    },
    trackAnalyticClick: (eventData) => {
      const loadtimer = setTimeout(() => {
        dispatch(setClickAnalyticsData(eventData));
        // Delayed setting of data when redirection on click event
        clearTimeout(loadtimer);
      }, 300);
      const timer = setTimeout(() => {
        dispatch(trackClick(eventData));
        clearTimeout(timer);
      }, 800);
    },
    updateSectionStateAtn: (payload) =>
      dispatch(updateSectionState({ id: SPC_SECTION.SHIPPING, section: payload })),
    togglePlccModalStateAction: (payload) => dispatch(togglePlccLoginModal(payload)),
  };
}

const withReducer = withDynamicReducer([
  { key: 'AddressBookReducer', reducer: AddressBookReducer },
  { key: 'AddedToBagReducer', reducer: AddedToBagReducer },
]);

const withSaga = withDynamicSaga([
  { key: 'addressBookSaga', saga: AddressBookSaga },
  { key: 'AddedToBagSaga', saga: AddedToBagSaga },
]);
export default compose(
  withReducer,
  withSaga,
  connect(mapStateToProps, mapDispatchToProps)
)(OrderLedgerContainer);

export const OrderLedgerContainerVanilla = OrderLedgerContainer;
